












































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import 'vue2-datepicker/index.css'
import Icon from '@/components/Icon.vue'
import { Debounce } from 'vue-debounce-decorator'
import InputV2 from '@/components/inputsV2/InputV2.vue'

const DateRangePicker = require('vue2-datepicker').default
@Component({
  props: {
    value: {
      type: String
    },
    trimIdentical: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    }
  },
  components: {
    InputV2,
    Icon,
    DateRangePicker
  }
})

export default class TableInputDateRangePicker extends Vue {
  isError: boolean = false
  date: Date [] | string [] = ['', '']

  @Debounce(100)
  emitInput (value: any) {
    this.$emit('input', value ? value.join(';') : '')
  }

  get rangeValue () {
    const [dateFrom, dateTo] = this.date
    if (!dateFrom || dateFrom === 'Invalid date') {
      return ''
    }
    if (dateFrom === dateTo) {
      return dateFrom
    }
    return dateFrom + '-' + dateTo
  }

  mounted () {
    if (this.$props.value) {
      this.date = this.$props.value.split(/[-;]+/)
    }

    this.$watch('$props.value', (val) => {
      this.date = val ? val.split(/[-;]+/) : val
    })
  }

  handleInput (value: any) {
    if (!value) {
      this.emitInput('')
    }
    const dateRegExp = '(1[0-2]|0[1-9])/(3[01]|[12][0-9]|0[1-9])/\\d{4}'
    const dateRangeRegExp = new RegExp(`${dateRegExp}-${dateRegExp}`, 'g')
    if (dateRangeRegExp.test(value)) {
      const val = value.split('-')
      this.date = val
      this.emitInput(val)
    }
  }
}

